export default "__VITE_ASSET__CKi48HFF__"